import script from "./ConsoleLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsoleLayout.vue?vue&type=script&setup=true&lang=js"

import "./ConsoleLayout.vue?vue&type=style&index=0&id=269707ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-269707ea"]])

export default __exports__